'use strict';
/* ==========================================================================
   levels/map.js — the hub: an open engineer's notebook on a kraft desk.
   Left page: heading, Dr. Voss + speech bubble, a tiny blueprint doodle.
   Right page: three paper luggage tags → Game.replace(new Levels[id]()).
   A completed step gets a rubber stamp (slammed in when you just earned it);
   the first step not done yet gets a red "next!" arrow.
   ========================================================================== */
(function () {
  const TAGS = [
    { id: 'video', n: 1, title: 'The Big Drop', sub: 'watch · 4 questions', x: 1380, y: 330, rot: -0.03, color: PAL.red },
    { id: 'spot', n: 2, title: 'Spot the Mistake', sub: '6 clips · OBJECTION!', x: 1395, y: 545, rot: 0.025, color: PAL.mustard },
    { id: 'rap', n: 3, title: "Energy Don't Quit", sub: 'the rap', x: 1370, y: 760, rot: -0.018, color: PAL.teal },
  ];
  const TAG_W = 700, TAG_H = 160;
  const nextStep = () => TAGS.find(tg => !Game.progress.stamps[tg.id]);
  // Voss's line on the map (captions only; there is no VO for the map)
  const SAY = {
    hello: 'Three stops. Start with the big drop. Hard hats optional.',
    spot: 'You know where the energy hides. Now catch my broken coasters: tag two.',
    rap: 'One more stop. The rap. Yes, really.',
    video: 'You skipped ahead. Tag one explains everything you just did.',
    done: 'All three stamped. Energy: conserved. So are you.',
  };

  function page(x, w, seed, margin) {
    paperRect(x, 545, w, 960, PAL.cream, { seed, depth: 1.6, boil: false });
    for (let y = 190; y < 1010; y += 58) ink([[x - w / 2 + 16, y], [x + w / 2 - 16, y]], { w: 2, color: 'rgba(90,150,190,0.45)', seed: seed * 50 + y, passes: 1, step: 80, amp: 0.8 });
    if (margin) ink([[margin, 80], [margin, 1015]], { w: 2.5, color: 'rgba(224,83,61,0.6)', seed: seed + 7, passes: 1, step: 80, amp: 0.8 });
  }

  function drawTag(tg, hover, t0) {
    const s = pop(T, t0 + 0.35 + tg.n * 0.14, 0.4, 2.2);
    if (s <= 0) return;
    g.save();
    g.translate(tg.x, tg.y + (hover ? -8 : 0)); g.rotate(tg.rot + (hover ? -0.015 : 0)); g.scale(s * (hover ? 1.03 : 1), s * (hover ? 1.03 : 1));
    ink([[-TAG_W / 2 + 40, 0], [-TAG_W / 2 - 30, -40], [-TAG_W / 2 - 60, 10]], { w: 4, color: '#8a6a45', seed: 40 + tg.n });
    paperRect(0, 0, TAG_W, TAG_H, PAL.white, { seed: 40 + tg.n, depth: hover ? 2 : 1.2 });
    paperRect(-TAG_W / 2 + 12, 0, 24, TAG_H - 10, tg.color, { seed: 45 + tg.n, depth: 0 });
    g.beginPath(); g.arc(-TAG_W / 2 + 40, 0, 10, 0, TAU); g.fillStyle = 'rgba(80,60,40,0.55)'; g.fill();
    paperCircle(-TAG_W / 2 + 140, 0, 58, tg.color, { seed: 50 + tg.n, depth: 0.7 });
    g.font = "84px 'Luckiest Guy'"; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillStyle = PAL.cream;
    g.fillText(String(tg.n), -TAG_W / 2 + 140, 6);
    hand(tg.title, -TAG_W / 2 + 232, -26, 66, t0 + 0.6 + tg.n * 0.14, { align: 'left', seed: 55 + tg.n });
    hand(tg.sub, -TAG_W / 2 + 236, 44, Math.min(48, UI.text(36)), t0 + 0.9 + tg.n * 0.14, { align: 'left', color: PAL.navy, seed: 58 + tg.n });
    g.restore();
  }

  /* a small blueprint doodle of the Big Drop on the left page */
  function doodle(t0) {
    const R = Tracks.get('s3'), vw = Coaster.view(495, 800, 2.8);
    const prog = E.outCubic(P(T, t0 + 0.5, t0 + 1.6));
    g.save();
    paperRect(705, 755, 470, 150, '#2f5f8f', { seed: 88, depth: 1, rot: 0.01, boil: false });
    Coaster.drawTrack(R.track, vw, { prog, posts: false, rail: 2, tieEvery: 5, seed: 8, color: PAL.cream });
    const st = R.sim.sample(((T - t0) % (R.sim.tSettle + 1.5)));
    if (prog >= 1) Coaster.drawCart(R.track, vw, st.s, { h: 18, rail: 2, seed: 9 });
    g.restore();
    hand('fig. 1: the big drop (20 m)', 705, 862, 30, t0 + 1.2, { color: PAL.navy, seed: 89 });
  }

  class MapScene extends Scene {
    enter() {
      const st = Game.progress.stamps;
      this.allDone = TAGS.every(tg => st[tg.id]);
      const nx = nextStep();
      this.say = this.allDone ? SAY.done : !nx ? SAY.hello : nx.id === 'video' && (st.spot || st.rap) ? SAY.video : nx.id === 'video' ? SAY.hello : SAY[nx.id];
      this.stampNew = Game._justStamped; Game._justStamped = null;
      Audio.play('paper', { gain: 0.5 });
      Audio.music(Game.MUSIC, { gain: 0.3 });
    }

    open(tg) {
      Audio.play('pop', { gain: 0.6 });
      const C = Levels[tg.id];
      if (typeof C === 'function') Game.replace(new C());
      else UI.toast('coming soon');
    }
    keyDown(k) {
      const n = parseInt(k, 10);
      if (n >= 1 && n <= TAGS.length) this.open(TAGS[n - 1]);
      if (k === 'Enter') this.open(nextStep() || TAGS[0]);
    }

    draw() {
      UI.allLessons();                       // "← All lessons": back to the site's home page (core/ui.js)
      const t0 = this.enteredAt, t = this.t;
      // desk + open notebook
      g.fillStyle = paperTile(PAL.kraft, 3, 'tex_kraft'); g.fillRect(0, 0, Game.W, Game.H);
      page(548, 830, 81, 232);
      page(1372, 830, 82, null);
      const gut = g.createLinearGradient(930, 0, 990, 0);
      gut.addColorStop(0, 'rgba(60,40,20,0)'); gut.addColorStop(0.5, 'rgba(60,40,20,0.28)'); gut.addColorStop(1, 'rgba(60,40,20,0)');
      g.fillStyle = gut; g.fillRect(930, 65, 60, 960);
      for (let y = 110; y < 1010; y += 64) inkCircle(960, y, 15, { w: 4, sx: 1.6, color: '#6b6f78', seed: 90 + y, step: 6 });
      texScrap('tex_news', 1760, 1010, 300, 150, { rot: 0.12, seed: 21, depth: 1 });
      tape(170, 90, 160, -0.7, undefined, 5); tape(1760, 90, 160, 0.7, undefined, 6);

      ransom('ENERGY', 560, 172, 70, t0 + 0.15, { seed: 303 });
      ransom('THE LESSON', 1372, 172, 52, t0 + 0.3, { seed: 304 });
      doodle(t0);

      // Dr. Voss + speech
      const rise = E.outBack(P(T, t0 + 0.2, t0 + 0.7), 1.4);
      Puppet.draw('voss', 290, 1045 + (1 - rise) * 500, 470, { facing: 1, t: T, pose: this.allDone ? 'point' : null, env: t > 0.6 && t < 3 ? 0.25 + 0.25 * Math.sin(T * 17) : 0 });
      if (t > 0.6 && !UI.docked()) UI.speech(this.say, 660, 350, { side: 'left', w: 480, t0: t0 + 0.6 });

      // portrait phone: the steps are full-width rows in the dock (core/dock.js Dock.map); the tags are only the picture
      const docked = UI.docked();
      if (docked) Dock.map({ say: this.say, who: 'Dr. Voss', open: id => this.open(TAGS.find(tg => tg.id === id)) });
      // tags (+ stamps)
      TAGS.forEach(tg => {
        const hit = docked ? { hover: false, clicked: false } : UI._hit('tag' + tg.n, tg.x, tg.y, TAG_W, TAG_H);
        if (hit.hover && !this['hov' + tg.n]) Audio.play('paper', { gain: 0.2, rate: 1.3 });
        this['hov' + tg.n] = hit.hover;
        drawTag(tg, hit.hover, t0);
        if (Game.progress.stamps[tg.id]) {
          let s = 1;
          if (this.stampNew === tg.id) {
            const at = t0 + 0.9;
            s = pop(T, at, 0.18, 1.2) * (1 + 1.4 * (1 - P(T, at, at + 0.12)));
            if (T >= at && !this.stampPlayed) { this.stampPlayed = true; Audio.play('stamp'); }
          } else s = pop(T, t0 + 0.8, 0.25, 1.5);
          const sc = Game.progress.scores.spot;
          UI.stamp(tg.id === 'spot' && sc && sc.best != null ? `${sc.best}/${sc.of || 12}` : 'DONE', tg.x + 262, tg.y + 36, { rot: -0.16, s: s * 0.56 });
        }
        // "next!" doodle arrow pointing at the first step not yet done
        if (!this.allDone && nextStep() === tg) {
          const ns = pop(T, t0 + 1.4, 0.4), bob = Math.sin(T * 4) * 8;
          if (ns > 0) {
            g.save(); g.globalAlpha = ns;
            inkArrow(tg.x + TAG_W / 2 + 105 + bob, tg.y - 22, tg.x + TAG_W / 2 + 16 + bob, tg.y, { w: 6, color: PAL.red, seed: 600 + tg.n, bulge: -20 });
            hand('next!', tg.x + TAG_W / 2 + 92 + bob, tg.y - 56, 42, 0, { dur: 0.01, color: PAL.red, rot: 0.1, seed: 610 + tg.n });
            g.restore();
          }
        }
        if (hit.clicked) this.open(tg);
      });
    }
  }
  MapScene.TAGS = TAGS.map(tg => ({ id: tg.id, x: tg.x, y: tg.y }));

  Levels.map = MapScene;
})();
